import React from 'react';
import styled from '@emotion/styled';
import {
	ArrowIcon,
	BusIcon,
	CalendarIcon,
	CancelIcon,
	ChevronDownIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ChevronUpIcon,
	DeleteIcon,
	DownloadIcon,
	ExternalLinkIcon,
	FacebookIcon,
	InfoIcon,
	InfoOutlineIcon,
	InstagramIcon,
	ITheme,
	MenuIcon,
	PdfIcon,
	PhoneIcon,
	ReplayIcon,
	SearchIcon,
	TwitterIcon,
	WalkIcon,
	YouTubeIcon,
} from '../../../ui';
import { CreditCardType } from '../../payment/domain/models';
import { CreditCardLogo } from '../../payment/ui/credit-card/logo';
import themed from '../../../ui/themer/themed';

const IconsWrap = styled.div`
	padding: 5px;

	img,
	svg {
		display: inline-block;
		margin: 5px;
	}
`;

const DarkBackground = styled(IconsWrap)<{}, ITheme>`
	background: ${themed(({ background }) => background.highlight)};
`;

export const Icons = () => (
	<>
		<h2 id="icons">Icons</h2>
		<IconsWrap>
			<ArrowIcon />
			<CalendarIcon />
			<CancelIcon />
			<ChevronDownIcon />
			<ChevronLeftIcon />
			<ChevronRightIcon />
			<ChevronUpIcon />
			<PdfIcon />
			<DownloadIcon />
			<ExternalLinkIcon />
			<MenuIcon />
			<PhoneIcon />
			<SearchIcon />
			<FacebookIcon />
			<InstagramIcon />
			<TwitterIcon />
			<YouTubeIcon />
			<InfoIcon />
			<InfoOutlineIcon />
			<BusIcon />
			<WalkIcon />
			<DeleteIcon />
			<ReplayIcon />
		</IconsWrap>
		<IconsWrap>
			<ArrowIcon variation="highlight" />
			<CalendarIcon variation="highlight" />
			<CancelIcon variation="highlight" />
			<ChevronDownIcon variation="highlight" />
			<ChevronLeftIcon variation="highlight" />
			<ChevronRightIcon variation="highlight" />
			<ChevronUpIcon variation="highlight" />
			<PdfIcon variation="highlight" />
			<DownloadIcon variation="highlight" />
			<ExternalLinkIcon variation="highlight" />
			<MenuIcon variation="highlight" />
			<PhoneIcon variation="highlight" />
			<SearchIcon variation="highlight" />
			<FacebookIcon variation="highlight" />
			<InstagramIcon variation="highlight" />
			<TwitterIcon variation="highlight" />
			<YouTubeIcon variation="highlight" />
			<InfoIcon variation="highlight" />
			<InfoOutlineIcon variation="highlight" />
			<BusIcon variation="highlight" />
			<WalkIcon variation="highlight" />
			<DeleteIcon variation="highlight" />
			<ReplayIcon variation="highlight" />
		</IconsWrap>
		<DarkBackground>
			<ArrowIcon variation="inverted" />
			<CalendarIcon variation="inverted" />
			<CancelIcon variation="inverted" />
			<ChevronDownIcon variation="inverted" />
			<ChevronLeftIcon variation="inverted" />
			<ChevronRightIcon variation="inverted" />
			<ChevronUpIcon variation="inverted" />
			<PdfIcon variation="inverted" />
			<DownloadIcon variation="inverted" />
			<ExternalLinkIcon variation="inverted" />
			<MenuIcon variation="inverted" />
			<PhoneIcon variation="inverted" />
			<SearchIcon variation="inverted" />
			<FacebookIcon variation="inverted" />
			<InstagramIcon variation="inverted" />
			<TwitterIcon variation="inverted" />
			<YouTubeIcon variation="inverted" />
			<InfoIcon variation="inverted" />
			<InfoOutlineIcon variation="inverted" />
			<BusIcon variation="inverted" />
			<WalkIcon variation="inverted" />
			<DeleteIcon variation="inverted" />
			<ReplayIcon variation="inverted" />
		</DarkBackground>

		<IconsWrap>
			<CreditCardLogo type={CreditCardType.Mastercard} />
			<CreditCardLogo type={CreditCardType.AmericanExpress} />
			<CreditCardLogo type={CreditCardType.Visa} />
		</IconsWrap>
	</>
);
